<p class="text-center text-white uppercase"
   style="background-color:#e71318; padding:10px 0; font-size:2.4rem; font-weight:500; letter-spacing:1.5px; line-height:1.1; margin-bottom:10px">
  Homegrown Indian Brand
</p>
